/*
const paymentDetail = {
  paymentDetail_Id: '', // leave blank to generate a new ID
  psdSerialNo: 0,
  psdNo: '',
  paymentScheduleId: '', // replace with the ID of the payment schedule record
  payment_id: '',
  no: 0,
  from: '',
  to: '',
  days: 0,
  mediaAmount: 0,
  productionAmount: 0,
  totalAmount: 0,
  paymentDue: '',
  invoiceDue: '',
  paymentStatus: 'Active',
  invoiceStatus: 'Active',
  userCode: '',
  userName: ''
};
*/
const util = require('@/utilFunction');

export function generateSchedulePerDay(
  totalAmount,
  campaignStart,
  campaignEnd,
  perScheduleDays,
  earlyDeposit = 0,
  contractType
) {
  const earlyDepositDay = earlyDeposit;
  const totalDay =
    Math.ceil((campaignEnd - campaignStart) / (1000 * 60 * 60 * 24)) + 1;
  // if(earlyDepositDay>totalDay){
  //     earlyDeposit -= 1;
  // }
  const earlyDepositObj = getLastNDaysRange(
    totalAmount,
    campaignStart,
    campaignEnd,
    earlyDepositDay
  );
  campaignEnd = earlyDeposit > 0 ? earlyDepositObj.campaignEnd : campaignEnd;
  totalAmount -= earlyDepositObj.totalAmount;

  const dayRange =
    Math.ceil((campaignEnd - campaignStart) / (1000 * 60 * 60 * 24)) + 1;
  const amountPerDay = totalAmount / dayRange;
  const schedule = [];
  if (earlyDeposit > 0) {
    schedule.push({
      From: earlyDepositObj.startDate,
      To: earlyDepositObj.endDate,
      totalDays: earlyDepositDay,
      amount: earlyDepositObj.totalAmount,
      totalAmount: earlyDepositObj.totalAmount,
      schedule: `${earlyDeposit}-Day Deposit`,
      no: 0,
    });
  }

  for (let i = 0; i < Math.ceil(dayRange / perScheduleDays); i++) {
    const From = new Date(
      campaignStart.getTime() + i * perScheduleDays * 86400000
    );
    const To = new Date(
      Math.min(
        From.getTime() + (perScheduleDays - 1) * 86400000,
        campaignEnd.getTime()
      )
    );
    const totalDays = Math.ceil((To - From) / (1000 * 60 * 60 * 24)) + 1;
    const amount = amountPerDay * totalDays;
    const totalAmount = amountPerDay * totalDays;
    schedule.push({
      From,
      To,
      totalDays,
      amount,
      totalAmount,
      schedule: i + 1,
      no: i + 1,
    });
  }

  const lastInstallment = schedule[schedule.length - 1];
  const lastInstallmentStart = lastInstallment.From;
  const totalDays =
    Math.ceil((campaignEnd - lastInstallmentStart) / (1000 * 60 * 60 * 24)) + 1;
  lastInstallment.totalDays = totalDays;
  lastInstallment.amount = amountPerDay * totalDays;

  schedule.map((val, index) => {
    if (earlyDeposit > 0 && index == 0) {
      makeFullRow(val, 21, 14, campaignStart);
    } else {
      makeFullRow(val, 30, 14);
    }
    schedule[index].From = formatDateSlash(val.From);
    schedule[index].To = formatDateSlash(val.To);
  });
  return remapToCurrentObj(schedule, contractType);
}

function remapToCurrentObj(schedule, contractType) {
  var Result = [];
  schedule.map((val, index) => {
    Result.push({
      days: val.totalDays,
      from: val.From,
      invoiceDate: '',
      invoiceStatus: 'notinvoiced',
      mediaAmount: contractType == 'media' ? val.amount : 0,
      no: val.no,
      paymentDue: val.paymentDue,
      paymentStatus: 'immediately',
      productionAmount: contractType == 'production' ? val.amount : 0,
      schedule: val.schedule,
      to: val.To,
      totalAmount: val.totalAmount,
    });
  });
  return Result;
}

// const totalAmount1 = 150000;
// const campaignStart1 = new Date('2024-01-01');
// const campaignEnd1 = new Date('2024-06-15');
// const perScheduleMonths1 = 28;
// const earlyDeposit = 0;

// const schedule1 = generateSchedulePerDay(totalAmount1, campaignStart1, campaignEnd1, perScheduleMonths1,earlyDeposit);

// console.log(schedule1);

// export function generateSchedulePerMonth(totalAmount, campaignStart, campaignEnd, perScheduleMonths, fixDate = 0) {
//     const monthRange = (campaignEnd.getMonth() - campaignStart.getMonth()) + 12 * (campaignEnd.getFullYear() - campaignStart.getFullYear()) + 1;
//     const amountPerMonth = totalAmount / monthRange;
//     const schedule = [];

//     for (let i = 0; i < Math.ceil(monthRange / perScheduleMonths); i++) {
//         const installmentStart = new Date(campaignStart.getTime());
//         installmentStart.setMonth(campaignStart.getMonth() + i * perScheduleMonths);
//         const installmentEnd = new Date(installmentStart.getTime());
//         installmentEnd.setMonth((installmentStart.getMonth() + perScheduleMonths));
//         if (fixDate != 0) {
//             if (i != 0) {
//                 installmentEnd.setDate(fixDate - 1);
//                 installmentStart.setDate(fixDate);
//             }
//         } else {
//             installmentEnd.setDate(installmentEnd.getDate() - 1);
//         }
//         const totalDays = Math.round((installmentEnd - installmentStart) / (1000 * 60 * 60 * 24)) + 1;
//         const amount = Math.round(amountPerMonth * perScheduleMonths).toFixed(2);
//         schedule.push({
//             From: installmentStart,
//             To: installmentEnd,
//             totalDays,
//             amount
//         });
//     }

//     const lastInstallment = schedule[schedule.length - 1];
//     const totalDays = Math.round((campaignEnd - lastInstallment.From) / (1000 * 60 * 60 * 24)) + 1;

//     if (totalDays < 20) {
//         const previousInstallment = schedule[schedule.length - 2];
//         previousInstallment.To = new Date(lastInstallment.To.getTime());
//         if (fixDate != 0) {
//             previousInstallment.To.setDate(fixDate);
//         }
//         previousInstallment.totalDays += totalDays;
//         previousInstallment.amount = (parseFloat(previousInstallment.amount) + parseFloat(lastInstallment.amount)).toFixed(2);
//         schedule.pop();
//         schedule[schedule.length - 1].To = campaignEnd;
//     } else {
//         lastInstallment.totalDays = totalDays;
//     }
//     return schedule;
// }

// const totalAmount = 150000;
// const campaignStart = new Date('2024-01-01');
// const campaignEnd = new Date('2024-06-15');
// const perScheduleMonths = 1;
// const fixDate = 15;

// const schedule = generateSchedulePerMonth(totalAmount, campaignStart, campaignEnd, perScheduleMonths, fixDate);

// console.log(schedule);

export function generateSchedulePerMonth(
  totalAmount,
  campaignStart,
  campaignEnd,
  perScheduleMonths,
  fixDate = 15
) {
  const schedule = [];

  function formatDate(date) {
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    return new Date(year, month, day);
  }

  let startDate = new Date(campaignStart);
  let endDate = new Date(startDate);
  endDate.setMonth(endDate.getMonth() + perScheduleMonths);

  const totalDays = (campaignEnd - campaignStart) / (1000 * 60 * 60 * 24);
  const firstInstallmentDays = Math.round(
    (new Date(campaignStart).setDate(fixDate) - campaignStart) /
      (1000 * 60 * 60 * 24)
  );
  const remainingDays = totalDays - firstInstallmentDays;
  if (firstInstallmentDays > 40) {
    const firstEndDate = new Date(startDate);
    firstEndDate.setDate(startDate.getDate() + 39);

    const firstAmount = totalAmount * 0.5;
    const secondAmount = totalAmount - firstAmount;

    schedule.push({
      From: formatDate(startDate),
      To: formatDate(firstEndDate),
      totalDays: 40,
      amount: firstAmount.toFixed(2),
    });

    startDate = new Date(firstEndDate);
    startDate.setDate(startDate.getDate() + 1);
    endDate = new Date(startDate);
    endDate.setMonth(endDate.getMonth() + perScheduleMonths);

    schedule.push({
      From: formatDate(startDate),
      To: formatDate(endDate),
      totalDays: Math.round((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1,
      amount: secondAmount.toFixed(2),
    });
  } else {
    const amount = totalAmount / (totalDays / 30);

    const from = formatDate(startDate);
    const to = new Date(endDate.getTime() - 1);
    to.setDate(fixDate - 1);

    schedule.push({
      From: from,
      To: formatDate(to),
      totalDays: Math.round((to - startDate) / (1000 * 60 * 60 * 24)) + 1,
      amount: amount.toFixed(2),
    });

    startDate = new Date(to);
    startDate.setDate(fixDate);
    endDate = new Date(startDate);
    endDate.setMonth(endDate.getMonth() + perScheduleMonths);

    while (endDate <= campaignEnd) {
      const from = formatDate(startDate);
      const to = new Date(endDate.getTime() - 1);
      to.setDate(fixDate - 1);

      schedule.push({
        From: from,
        To: formatDate(to),
        totalDays: Math.round((to - startDate) / (1000 * 60 * 60 * 24)) + 1,
        amount: amount.toFixed(2),
      });

      startDate = new Date(to);
      startDate.setDate(fixDate);
      endDate = new Date(startDate);
      endDate.setMonth(endDate.getMonth() + perScheduleMonths);
    }

    if (endDate > campaignEnd) {
      const daysInPeriod = Math.round(
        (campaignEnd - startDate) / (1000 * 60 * 60 * 24)
      );
      const amount =
        (totalAmount /
          ((campaignEnd - campaignStart) / (1000 * 60 * 60 * 24))) *
        daysInPeriod;

      const from = formatDate(startDate);
      const to = formatDate(campaignEnd);

      if (schedule.length > 0 && daysInPeriod < 20) {
        const last = schedule.pop();
        last.To = to;
        last.totalDays += daysInPeriod;
        last.amount = ((parseFloat(last.amount) + amount) / 2).toFixed(2);
        schedule.push(last);
      } else {
        schedule.push({
          From: from,
          To: to,
          totalDays: daysInPeriod + 1,
          amount: amount.toFixed(2),
        });
      }
    }
  }

  return schedule;
}

export function splitDateRangeByMonth(
  start,
  end,
  totalAmount,
  earlyDeposit,
  fixDate = null
) {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const result = [];
  const monthRange =
    endDate.getMonth() -
    startDate.getMonth() +
    12 * (endDate.getFullYear() - startDate.getFullYear()) +
    1;
  console.log(monthRange);

  var firstStartDays = startDate.getDate();
  var nextStartDays = startDate.getDate();
  var firstRowMonthCheck = startDate.getMonth();
  var currentEnd =
    nextStartDays !== 1
      ? nextStartDays - 1
      : getEndOfMonth(startDate).getDate();
  if (firstStartDays != 1) {
    firstRowMonthCheck += 1;
  }
  var nextStart;
  if (fixDate) {
    nextStartDays = fixDate;
    currentEnd = fixDate - 1;
  }

  var firstRow = { From: startDate, To: null };
  var dateForCal = new Date(
    startDate.getFullYear(),
    firstRowMonthCheck,
    currentEnd
  );
  if (fixDate && firstStartDays >= fixDate) {
    dateForCal = new Date(
      startDate.getFullYear(),
      startDate.getMonth() + 1,
      currentEnd
    );
  }
  var totalDays = dateDiffInDays(startDate, dateForCal);
  console.log(dateForCal, totalDays);
  if (totalDays < 20) {
    if (fixDate == null) {
      currentEnd = getEndOfMonth(
        new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1)
      ).getDate();
    }
    firstRow.To = new Date(
      startDate.getFullYear(),
      startDate.getMonth() + 1,
      currentEnd
    );
  } else {
    firstRow.To = dateForCal;
  }
  result.push(firstRow);
  if (nextStartDays == 1) {
    nextStart = new Date(
      firstRow.To.getFullYear(),
      firstRow.To.getMonth() + 1,
      nextStartDays
    );
  } else {
    nextStart = new Date(
      firstRow.To.getFullYear(),
      firstRow.To.getMonth(),
      nextStartDays
    );
  }

  // handle middle row
  for (let i = 1; i < monthRange; i++) {
    const row = { From: nextStart, To: null };
    const currentEnd =
      nextStartDays !== 1
        ? nextStartDays - 1
        : getEndOfMonth(nextStart).getDate();
    var month = nextStart.getMonth();
    if (nextStartDays != 1) {
      month += 1;
    }
    // const currentEnd = fixDate ? fixDate - 1 : nextStartDays - 1;
    row.To = new Date(nextStart.getFullYear(), month, currentEnd);
    if (row.From > endDate && row.To > endDate) {
      break;
    }

    result.push(row);
    nextStart = new Date(
      nextStart.getFullYear(),
      nextStart.getMonth() + 1,
      nextStartDays
    );
  }

  // last row handle
  const lastRow = result[result.length - 1];
  lastRow.To = endDate;
  var lastRowDays = dateDiffInDays(lastRow.From, lastRow.To);
  console.log(lastRowDays);
  if (lastRowDays < 20) {
    result.pop();
    result[result.length - 1].To = endDate;
  }
  console.log(result);
  result.map((val, index) => {
    var totalDays = dateDiffInDays(val.From, val.To);
    var amount = totalAmount / result.length;
    val.totalDays = totalDays;
    val.amount = amount.toFixed(2);
  });

  if (earlyDeposit > 0) {
    var earlyDepositRow = result.slice(
      result.length - earlyDeposit,
      result.length
    );
    const temp = {
      From: earlyDepositRow[0].From,
      To: earlyDepositRow[earlyDepositRow.length - 1].To,
      totalDays: earlyDepositRow
        .map((val) => val.totalDays)
        .reduce((a, b) => a + b),
      amount: earlyDepositRow
        .map((val) => parseFloat(val.amount))
        .reduce((a, b) => a + b)
        .toFixed(2),
    };
    result.splice(result.length - earlyDeposit, result.length);
    result.unshift(temp);
    console.log(result);
  }

  result.map((val, index) => {
    if (earlyDeposit > 0 && index == 0) {
      makeFullRow(val, 21, 14, start);
    } else {
      makeFullRow(val, 30, 14);
    }
    result[index].From = formatDateSlash(val.From);
    result[index].To = formatDateSlash(val.To);
  });

  //console.log(result);
  return result;
}

export function formatDateSlash(date) {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
}

export function dateDiffInDays(date1, date2) {
  const diffInMs = Math.abs(date2 - date1);
  const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
  return diffInDays + 1;
}

export function getEndOfMonth(date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const firstDayOfMonth = new Date(`${year}-${month}-01`);
  const lastDayOfMonth = new Date(firstDayOfMonth);
  lastDayOfMonth.setMonth(lastDayOfMonth.getMonth() + 1);
  lastDayOfMonth.setDate(lastDayOfMonth.getDate() - 1);
  return lastDayOfMonth;
}

export function subtractDays(date, n) {
  const result = new Date(date);
  result.setTime(result.getTime() - n * 24 * 60 * 60 * 1000);
  return result;
}

//pt = payment term, it = invoice term
export function makeFullRow(row, pt, it, campaignStart = null) {
  var from = new Date(row.From);
  if (campaignStart) {
    from = new Date(campaignStart);
  }

  row.paymentDue = subtractDays(from, pt);
  row.invoiceDue = subtractDays(row.paymentDue, it);

  row.paymentDue = formatDateSlash(row.paymentDue);
  row.invoiceDue = formatDateSlash(row.invoiceDue);
  //return row;
}

export function getLastNDaysRange(totalAmount, startDate, endDate, n) {
  const dayRange = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
  const amountPerDay = totalAmount / dayRange;
  const lastNStartDate = new Date(
    startDate.getTime() + (dayRange - n) * 86400000
  );
  const campaignEnd = new Date(
    startDate.getTime() + (dayRange - n - 1) * 86400000
  );
  const lastNDays = Array.from(
    {
      length: n,
    },
    (_, i) => new Date(startDate.getTime() + (dayRange - n + i) * 86400000)
  );
  const totalAmountLastNDays = n * amountPerDay;

  return {
    startDate: lastNStartDate,
    endDate,
    dayRange: n,
    campaignEnd,
    totalAmount: totalAmountLastNDays,
  };
}

export function getFixDueDate(date, fixDate, last, lastYear) {
  if (!date) {
    return date;
  }

  if (typeof date == 'string') {
    date = new Date(date);
  }
  var lastDayOfMonth = new Date(date.getFullYear(), last + 1, 0).getDate();
  if (parseInt(fixDate) > lastDayOfMonth) {
    fixDate = lastDayOfMonth;
  }
  var month = date.getMonth();
  //var day = date.getDate();
  if (last != 0) {
    month = last;
  }
  var year = date.getFullYear();
  if (last == 12) {
    year = lastYear;
  }
  var result = new Date(year, month, fixDate);
  date.setHours(0, 0, 0, 0);
  result.setHours(0, 0, 0, 0);
  console.log(result, date);
  if (result >= date && last == 0) {
    result = new Date(year, month - 1, fixDate);
  }
  return result;
}

export function findLastEndDateExcludeBonus(mediaArr) {
  var lastEndDate = new Date(2000, 1, 1);
  mediaArr.map((val, index) => {
    if (val.isBonus) {
      return;
    }
    var endDate = new Date(val.EndDate);
    if (endDate > lastEndDate) {
      lastEndDate = endDate;
    }
  });
  return lastEndDate;
}

export function mergeSchedule(
  selectedScheduleArr,
  fullScheduleArrs,
  contractType,
  realDays
) {
  const dateJs = require('@/assets/js/date').default;

  var resultSchedule = {};
  var finalResult = [];
  var fullScheduleArr = JSON.parse(JSON.stringify(fullScheduleArrs));
  var totalRow = fullScheduleArr[fullScheduleArr.length - 1];

  selectedScheduleArr.sort(function compareFn(a, b) {
    //return b.Id - a.Id;
    return a.no - b.no;
  });
  var mediaAmount = 0;
  var productionAmount = 0;
  var totalAmount = 0;
  var days = 0;
  var selectedIndexInFull = null;

  selectedScheduleArr.map((val, index) => {
    mediaAmount = parseFloat(
      (mediaAmount + parseFloat(val.mediaAmount)).toFixed(2)
    );
    productionAmount = parseFloat(
      (productionAmount + parseFloat(val.productionAmount)).toFixed(2)
    );
    totalAmount = parseFloat(
      (totalAmount + parseFloat(val.totalAmount)).toFixed(2)
    );
    days += val.days;
  });

  fullScheduleArr.map((val, index) => {
    if (val.no == selectedScheduleArr[0].no) {
      selectedIndexInFull = index;
    }
  });
  console.log(selectedIndexInFull);
  if (selectedIndexInFull != null) {
    var temp = fullScheduleArr.splice(selectedIndexInFull);
    finalResult = fullScheduleArr;
    fullScheduleArr = temp;
  }
  console.log(finalResult, fullScheduleArr);
  resultSchedule = JSON.parse(JSON.stringify(selectedScheduleArr[0]));
  resultSchedule.checked = false;
  resultSchedule.to = dateJs.ConvertDate(
    dateJs.AddDays(resultSchedule.from, days - 1)
  );
  // resultSchedule.to = dateJs.ConvertDate(
  //   new Date(
  //     Math.min(
  //       new Date(resultSchedule.from).getTime() + (days - 1) * 86400000,
  //       new Date(
  //         selectedScheduleArr[selectedScheduleArr.length - 1].to
  //       ).getTime()
  //     )
  //   )
  // );
  resultSchedule.mediaAmount = mediaAmount;
  resultSchedule.productionAmount = productionAmount;
  resultSchedule.totalAmount = totalAmount;
  resultSchedule.days = days;

  console.log(resultSchedule, fullScheduleArr);
  // var remainAmount =
  //   fullScheduleArr[fullScheduleArr.length - 1].totalAmount -
  //   resultSchedule.totalAmount;
  // if (finalResult.length != 0) {
  //   finalResult.map((val, index) => {
  //     remainAmount -= val.totalAmount;
  //   });
  // }
  var remainAmount =
    fullScheduleArr
      .filter((t) => !t.isTotal)
      .map((t) => t.totalAmount)
      .reduce((a, b) => a + b) - totalAmount;
  var tempDate = new Date(resultSchedule.to);
  var campaignStart = tempDate.setDate(tempDate.getDate() + 1);
  finalResult.push(resultSchedule);
  if (
    fullScheduleArr.filter(
      (t) => parseInt(t.schedule) > parseInt(resultSchedule.schedule)
    ).length > 0
    // new Date(campaignStart) <
    //   new Date(fullScheduleArr[fullScheduleArr.length - 2].to)
  ) {
    // var others = generateSchedulePerDay(
    //   remainAmount,
    //   new Date(campaignStart),
    //   new Date(fullScheduleArr[fullScheduleArr.length - 2].to),
    //   realDays,
    //   0,
    //   contractType
    // );
    // others.map((val, index) => {
    //   finalResult.push(val);
    // });

    fullScheduleArr.map((t) => {
      if (t.checked || t?.isTotal) {
        return;
      }
      var newSchedule = { ...t };
      if (newSchedule.from) {
        newSchedule.from = dateJs.AddDays(
          finalResult[finalResult.length - 1].to,
          1
        );
      }
      if (newSchedule.to) {
        newSchedule.to = dateJs.AddDays(newSchedule.from, newSchedule.days - 1);
      }
      finalResult.push(newSchedule);
    });
  }

  finalResult.push(totalRow);
  console.log(rescheduleAllNo(finalResult));
  return rescheduleAllNo(finalResult);
}

export function rescheduleAllNo(scheduleArr) {
  var no = scheduleArr.sort((t) => t.schedule)[0].schedule;
  var temp = [];
  scheduleArr.map((val, index) => {
    if (val.isTotal) {
      temp.push(val);
      return;
    }
    val.no = no;
    val.schedule = no;
    temp.push(val);
    no++;
  });
  scheduleArr = temp;
  return scheduleArr;
}

export function breakEven(selectedScheduleArr, fullScheduleArrs, contractType) {
  var total = 0;
  selectedScheduleArr = selectedScheduleArr.sort(
    (a, b) => a.schedule - b.schedule
  );
  selectedScheduleArr.map((val, index) => {
    total += val.totalAmount;
  });
  var fullScheduleArr = JSON.parse(JSON.stringify(fullScheduleArrs)).sort(
    (t) => t.no
  );
  var totalRow = selectedScheduleArr.length;
  var average = parseFloat((total / totalRow).toFixed(2));
  var diffAmount = total;
  var result = [];
  fullScheduleArr.map((val, index) => {
    val.checked = false;
    if (val.isTotal) {
      result.push(val);
      return;
    }
    if (
      selectedScheduleArr.filter((val2) => {
        return val2.no == val.no;
      }).length == 0
    ) {
      result.push(val);
    } else {
      diffAmount = parseFloat((diffAmount - average).toFixed(2));

      if (
        diffAmount < average &&
        val.no == selectedScheduleArr[selectedScheduleArr.length - 1].no
      ) {
        average = parseFloat((average + diffAmount).toFixed(2));
      }
      if (contractType == 'media') {
        val.mediaAmount = average;
      } else {
        val.productionAmount = average;
      }
      val.totalAmount = average;
      result.push(val);
    }
  });
  return result;
}
